export const HealthIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
      <g fill="currentColor">
        <path d="M12 6.1a5.5 5.5 0 0 0-2.243.48A5.9 5.9 0 0 0 7.843 7.96a6.5 6.5 0 0 0-1.288 2.078A6.9 6.9 0 0 0 6.1 12.5v.6H4.9v-.6c0-.992.181-1.975.535-2.894a7.7 7.7 0 0 1 1.529-2.464 7.1 7.1 0 0 1 2.304-1.657A6.7 6.7 0 0 1 12 4.9a6.7 6.7 0 0 1 2.732.585 7.1 7.1 0 0 1 2.304 1.657 7.7 7.7 0 0 1 1.53 2.464A8.1 8.1 0 0 1 19.1 12.5v.6h-1.2v-.6c0-.846-.155-1.684-.455-2.463a6.5 6.5 0 0 0-1.289-2.078 5.9 5.9 0 0 0-1.913-1.378A5.5 5.5 0 0 0 12 6.1"></path>
        <path d="m14.146 9.146-3 3a.5.5 0 1 0 .707.707l3-3z"></path>
        <path
          fillRule="evenodd"
          d="M12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5m0-1.2a9.3 9.3 0 1 0 0-18.6 9.3 9.3 0 0 0 0 18.6"
          clipRule="evenodd"
        ></path>
      </g>
    </g>
  </svg>
);
